module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Sad-33a3114a45ad8be947f0a3872f3617d5d16ac4f154707eb2153c9a3ce11c3e96.svg";